import type { DatasetConfig } from '../types';
import { wellsConfig } from './wells.config';
import { portfolioAssetsConfig } from './portfolio-assets.config';
import { documentsConfig } from './documents.config';
import { areasConfig } from './areas-utils';
import { subsurfaceMapsConfig } from './subsurface-maps.config';

// Insertion order is tab and sidebar order: Areas sits between Documents and
// Petrotech Maps, as in the mock.
export const datasetRegistry: Record<string, DatasetConfig> = {
  wells: wellsConfig,
  portfolioAssets: portfolioAssetsConfig,
  documents: documentsConfig,
  areas: areasConfig,
  subsurfaceMaps: subsurfaceMapsConfig,
};
